import { render, staticRenderFns } from "./SwitchBase.vue?vue&type=template&id=25f5924c&"
import script from "./SwitchBase.vue?vue&type=script&lang=ts&"
export * from "./SwitchBase.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchBase.vue?vue&type=style&index=0&id=25f5924c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports